import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowCornerDownLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowCornerDownLeft"><Path d="M20.5 4.5V15H4" stroke="currentColor" strokeLinecap="square"/><Path d="M8 10.5L3.5 15L8 19.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowCornerDownLeft;
